import getCurrentSelectedTableView from 'mini-mail-list-store/lib/utils/getSelectedTableView';
import { executeMailSearch, incrementRowOffset } from '../actions/privateActions';
import { MAIL_QUERY_PAGE_SIZE } from 'mini-3s-service/lib/utils/constants';
import { when } from 'mobx';

/**
 * Loads more data into search tableView by calling executeMailSearch action.
 * Returns a promise which resolves once executeMailSearch operations are completed
 */
export async function loadMoreMailResults(): Promise<void> {
    incrementRowOffset(MAIL_QUERY_PAGE_SIZE);
    executeMailSearch();
    return when(() => !getCurrentSelectedTableView()?.isLoading);
}
